// @flow
import React from 'react';
import styled from 'styled-components';

import FlashBanner from 'containers/flash-banner';

import { BACKGROUND_COLOR_TERTIARY, WHITE } from 'styles/colors';

const Wrapper = ({ children, hasBackground = false }: any) => (
  <Container hasBackground={hasBackground}>
    <Main>
      <FlashBanner />
      {children}
    </Main>
  </Container>
);

export default Wrapper;

const Container = styled.div`
  background-color: ${props => (props.hasBackground ? BACKGROUND_COLOR_TERTIARY : WHITE)};
  min-height: 100vh;
`;

const Main = styled.div`
  display: block;
  margin: 0 auto;
  min-height: 100vh;
`;



// WEBPACK FOOTER //
// ./src/components/shared/wrapper/index.js